import { render, staticRenderFns } from "./PFormSwitch.vue?vue&type=template&id=340e6d22&scoped=true&"
import script from "./PFormSwitch.vue?vue&type=script&lang=ts&"
export * from "./PFormSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./PFormSwitch.vue?vue&type=style&index=0&id=340e6d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340e6d22",
  null
  
)

export default component.exports